/**
 * Builds contact's address string.
 * @param {object} contact - contact.
 * @returns {string} address string.
 */

export const getAddressString = (contact = {}) => {
  const addressKeys = [
    'address1',
    'address2',
    'city',
    'state',
    'country',
    'zipCode'
  ];
  const addressArray = [];

  addressKeys.forEach(key => {
    if (contact[key]) {
      addressArray.push(contact[key]);
    }
  });

  return addressArray.join(', ');
};
